export const numberWithCommas = (x) => {
    if(Number(x) < 1000) return x //for float number
    if (x) {
             
      return  x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  else {
      return  ''
  }  }